export default function ResizeHandle({panel, onPointerDown, onKeyDown, onReset}) {
    const label = panel === 'sidebar' ? 'Resize conversation sidebar' : 'Resize Thread panel';
    return (
        <div
            className={`chat-resize-handle is-${panel}`}
            role="separator"
            aria-label={label}
            aria-orientation="vertical"
            tabIndex={0}
            title="Drag to resize. Double-click to reset."
            onPointerDown={event => onPointerDown(panel, event)}
            onKeyDown={event => onKeyDown(panel, event)}
            onDoubleClick={() => onReset(panel)}
        />
    );
}
